import * as yup from 'yup';

const inviteMembersSchema = yup.object({
    name: yup
        .string()
        .transform((value) => value?.trim())
        .required('User Name is required')
        .min(2, 'Name must be at least 2 characters')
        .matches(
            /^[\p{L}\p{M}]+([ʼʹ’'`\- ][\p{L}\p{M}]+)*$/u,
            'Only letters, one space in row, dashes (-), and apostrophes (ʼ) are allowed',
        )
        .max(70),

    email: yup
        .string()
        .email('Please enter a valid email')
        .required('Email is required')
        .test('is-email-exists', 'Email already exists', function (value) {
            if (!value) return true;

            const { emails } = this.options.context || {};
            const invites = this.parent?.invites || [];

            const alreadyInvited = invites.some(
                (invite: { email: string }) => invite.email === value,
            );
            const alreadyExists = (emails || []).includes(value);

            return !alreadyExists && !alreadyInvited;
        }),
    invites: yup
        .array()
        .of(
            yup.object({
                name: yup.string().required('Name is required'),
                email: yup
                    .string()
                    .email('Please enter a valid email')
                    .required('Email is required'),
            }),
        )
        .default([]),
});

export type InviteMembersData = yup.InferType<typeof inviteMembersSchema>;

export default inviteMembersSchema;
